import { render, staticRenderFns } from "./singerDetail.vue?vue&type=template&id=59e7f33e&scoped=true"
import script from "./singerDetail.vue?vue&type=script&lang=js"
export * from "./singerDetail.vue?vue&type=script&lang=js"
import style0 from "./singerDetail.vue?vue&type=style&index=0&id=59e7f33e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e7f33e",
  null
  
)

export default component.exports